import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';


@Component({
  selector: 'app-BusinessStatementFiling',
  templateUrl: './BusinessStatementFiling.component.html',
  styleUrls: ['./BusinessStatementFiling.component.scss']
})
export class BusinessStatementFilingComponent implements OnInit {

  id: number;
  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/_U9iIUwfY04',
      title: 'Assessor Jeff Prang\'s Business Personal Property Statement Webinar (03/04/25)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/EJswhIach4M',
      title: 'Assessor Jeff Prang\'s Business Personal Property Statement Webinar (03/06/25)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/1nLaIoOIKH0',
      title: 'Business Personal Property Presentation 2024',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/gzRdcJwpVDk',
      title: 'Preparing the Business Personal Property Statement',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1680545747/Webinars%20and%20Presentations/Assessor_571-L_Seminar_Overview_2023_-_Final.pdf'
    },
    {
      url: 'https://www.youtube.com/embed/p0RDDQ0FoyQ',
      title: 'FORM 571-L Q & A RECORDED ZOOM',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/th4ngfa9C3c',
      title: 'How to Prepare a Business Personal Property Statement, Form 571-L (QUICK POWERPOINT)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/6r2KZriF5SE',
      title: 'How to Prepare a Business Personal Property Statement, Form 571-L (ENGLISH)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/nTyJ79thsw8',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Spanish)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/McZ0p2rf04w',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Chinese)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/-x62Y4i0GpQ',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Persian)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/5cd0MGUKl9A',
      title: 'HOW TO PREPARE A BUSINESS PERSONAL PROPERTY STATEMENT, FORM 571-L (Armenian)',
      powerpoint: null
    },
    // {
    //   url: 'https://www.youtube.com/embed/PQrvFBOjjWc',
    //   title: 'PROP. 19 – TAX BASE FROM AN ORIGINAL PROPERTY TO REPLACEMENT PROPERTY ANYWHERE IN THE STATE.',
    //   powerpoint: null
    // },
    // {
    //   url: 'https://www.youtube.com/embed/L9hIGHhMXYA',
    //   title: 'PROP. 19 – HOMEOWNERS’ EXEMPTION TO QUALIFY FOR THE PARENT-CHILD AND GRANDPARENT-GRANDCHILD EXCLUSIONS?',
    //   powerpoint: null
    // },
    // {
    //   url: 'https://www.youtube.com/embed/5aJ7iOz_zLs',
    //   title: 'Prop. 19 Town Hall (12/08/21)',
    //   powerpoint: null
    // },
    // {
    //   url: 'https://www.youtube.com/embed/OXc8TSyZhaA',
    //   title: '',
    //   powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1627751261/Webinars%20and%20Presentations/LA_County_Assessor_Prop._19_Webinar_1_22_21.pdf'
    // }
  ];

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }

  ngAfterViewInit() {
    console.log(this.id);
  }
  ngOnInit() {
  }

}
